/**
 * Tipos de tipos de ativos
 */

export enum ProcessRoleFieldType {
  STRING = "string",
  NUMBER = "number",
  DATE = "date",
  MONEY = "money",
}

export const ProcessRoleFieldTypeLabels: Record<ProcessRoleFieldType, string> = {
  [ProcessRoleFieldType.STRING]: "Alfanumérico",
  [ProcessRoleFieldType.NUMBER]: "Número",
  [ProcessRoleFieldType.DATE]: "Data",
  [ProcessRoleFieldType.MONEY]: "Valor Monetário",
};

export interface ProcessRoleFieldOption {
  value: string;
  key?: string;
}

export interface ProcessRoleFieldAdditionalData {
  _id?: string;
  name?: string;
  type?: ProcessRoleFieldType;
  required?: boolean;
  options?: ProcessRoleFieldOption[];
}

export interface ProcessRoleOutputDTO {
  _id?: string;
  name?: string;
  description?: string;
  additionalData?: ProcessRoleFieldAdditionalData[];
  createdAt?: Date;
  updatedAt?: Date;
}
